import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import errorImage from "../../assets/images/createPassword/errorImage.svg";
import errorImageright from "../../assets/images/createPassword/errorImageright.svg";
import errorImagewrong from "../../assets/images/createPassword/errorImagewrong.svg";
import hide from "../../assets/images/createPassword/hide.svg";
import show from "../../assets/images/createPassword/show.svg";
import darkShow from "../../assets/images/createPassword/darkShow.svg";
import darkHide from "../../assets/images/createPassword/darkHide.svg";
import Button from "components/Button/index";
import useTheme from "hooks/observer";

import "components/Password/password.scss";
const UpdatePassword = ({
  handleSave = () => { },
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  isPasswordVisible,
  setIsPasswordVisible,
  isConfirmPasswordVisible,
  setIsConfirmPasswordVisible,
  currentPassword,
  setCurrentPassword,
  showCurrentPassword = false,
  currentPasswordError = "",
  setCurrentPasswordError = () => { },
  isLoading = false
}) => {
  const [isValid, setIsValid] = useState(false);
  const [matchError, setMatchError] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isCurrentPasswordVisible, setIsCurrentPasswordVisible] = useState(false);

  const theme = useTheme();
  const hideImage = theme === "light" ? hide : darkShow;
  const showImage = theme === "light" ? show : darkHide;

  const handlePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleChangeCurrentPassword = (e) => {
    setCurrentPassword((prev) => ({
      ...prev,
      password: e.target.value
    }));
    if (currentPasswordError) {
      setCurrentPasswordError("");
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    checkPasswordRequirements(value);

    setMatchError(value && confirmPassword && value !== confirmPassword);

    setIsValid(
      value.length >= 12 &&
      /[a-z]/.test(value) &&
      /[A-Z]/.test(value) &&
      /\d/.test(value) &&
      /[#.?!@$%^&*-]/.test(value) &&
      value === confirmPassword
    );
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (!password || value !== password) {
      setMatchError(true);
    } else {
      setMatchError(false);
    }

    setIsValid(
      password.length >= 12 &&
      /[a-z]/.test(password) &&
      /[A-Z]/.test(password) &&
      /\d/.test(password) &&
      /[#.?!@$%^&*-]/.test(password) &&
      value === password
    );
  };

  const handleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const checkPasswordRequirements = (value) => {
    const lengthValid = value.length >= 12;
    const lowercaseValid = /[a-z]/.test(value);
    const uppercaseValid = /[A-Z]/.test(value);
    const numberValid = /\d/.test(value);
    const specialCharValid = /[#.?!@$%^&*-]/.test(value);
    setIsValid(
      lengthValid &&
      lowercaseValid &&
      uppercaseValid &&
      numberValid &&
      specialCharValid
    );
  };

  const getErrorStyle = (isValid) => ({
    color: !isValid && !isFocused ? "#99939F" : isValid ? "#339A33" : "#DC1818"
  });
  return (
    <>
      <div className="PasswordWrapper">
        <div className="PasswordValid">
          {showCurrentPassword && (
            <div className="password" style={{ marginBottom: "20px" }}>
              <div className="passwordField">
                <p className="title">Current Password</p>
                <div
                  className="passwordVisible"
                  style={{ border: currentPasswordError && "1px solid #DC1818" }}
                >
                  <input
                    type={isCurrentPasswordVisible ? "text" : "password"}
                    value={currentPassword.password}
                    onChange={handleChangeCurrentPassword}
                    placeholder="Enter current password"
                    required
                  />
                  <div
                    className="show-password"
                    style={{ cursor: "pointer" }}
                    onClick={() => setIsCurrentPasswordVisible(!isCurrentPasswordVisible)}
                  >
                    <img
                      src={isCurrentPasswordVisible ? showImage : hideImage}
                      alt="Toggle visibility"
                    />
                  </div>
                </div>
                {currentPasswordError && (
                  <p className="errorMessage" style={{ marginTop: "5px" }}>
                    {currentPasswordError}
                  </p>
                )}
              </div>
            </div>
          )}
          <div className="password">
            <div className="passwordField">
              <p className="title">New Password</p>
              <div className="passwordVisible">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  onChange={handlePasswordChange}
                  onFocus={() => setIsFocused(true)}
                  placeholder="Enter new password"
                  required
                />
                <div
                  className="show-password"
                  type="button"
                  role="switch"
                  style={{ cursor: "pointer" }}
                  aria-label={
                    isPasswordVisible ? "Hide password" : "Show password"
                  }
                  aria-checked={isPasswordVisible ? "true" : "false"}
                  onClick={handlePasswordVisibility}
                >
                  <img
                    src={isPasswordVisible ? showImage : hideImage}
                    alt="Toggle visibility"
                  />
                </div>
              </div>
            </div>
            <div className="passwordErrors">
              <div className="error">
                <img
                  src={
                    !isValid && !isFocused
                      ? errorImage
                      : /[a-z]/.test(password)
                        ? errorImageright
                        : errorImagewrong
                  }
                  alt="error"
                />
                <p style={getErrorStyle(/[a-z]/.test(password))}>
                  Lowercase character
                </p>
              </div>
              <div className="error">
                <img
                  src={
                    !isValid && !isFocused
                      ? errorImage
                      : /[#.?!@$%^&*-]/.test(password)
                        ? errorImageright
                        : errorImagewrong
                  }
                  alt="error"
                />
                <p style={getErrorStyle(/[#.?!@$%^&*-]/.test(password))}>
                  Special character
                </p>
              </div>
              <div className="error">
                <img
                  src={
                    !isValid && !isFocused
                      ? errorImage
                      : /[A-Z]/.test(password)
                        ? errorImageright
                        : errorImagewrong
                  }
                  alt="error"
                />
                <p style={getErrorStyle(/[A-Z]/.test(password))}>
                  Uppercase character
                </p>
              </div>
              <div className="error">
                <img
                  src={
                    !isValid && !isFocused
                      ? errorImage
                      : password.length >= 12
                        ? errorImageright
                        : errorImagewrong
                  }
                  alt="error"
                />
                <p style={getErrorStyle(password.length >= 12)}>
                  12 Characters minimum
                </p>
              </div>
              <div className="error">
                <img
                  src={
                    !isValid && !isFocused
                      ? errorImage
                      : /\d/.test(password)
                        ? errorImageright
                        : errorImagewrong
                  }
                  alt="error"
                />
                <p style={getErrorStyle(/\d/.test(password))}>
                  Numeric character
                </p>
              </div>
            </div>
          </div>
          <div className="confirmPassword">
            <p className="title">Confirm Password</p>
            <div
              className="confirmPasswordFeild"
              style={{ borderColor: matchError ? "#DC1818" : undefined }}
            >
              <input
                type={isConfirmPasswordVisible ? "text" : "password"}
                id="confirm-password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                placeholder="Renter new password"
                required
              />
              <div
                className="show-password"
                type="button"
                role="switch"
                style={{ cursor: "pointer" }}
                aria-label={
                  isConfirmPasswordVisible ? "Hide password" : "Show password"
                }
                aria-checked={isConfirmPasswordVisible ? "true" : "false"}
                onClick={handleConfirmPasswordVisibility}
              >
                <img
                  src={isConfirmPasswordVisible ? showImage : hideImage}
                  alt="Toggle visibility"
                />
              </div>
            </div>
            <p
              className="errorMessage"
              id="match"
              style={{ visibility: matchError ? "visible" : "hidden", height: "18px", margin: 0, display: "block", lineHeight: "18px" }}
            >
              Passwords don&apos;t match
            </p>
          </div>
        </div>
        <Button
          type="violet"
          title={isLoading ? "Updating..." : "Update"}
          className={`PasswordSubmit ${password === confirmPassword ? "active" : "inactive"}`}
          disabled={
            isLoading ||
            !(
              (showCurrentPassword ? currentPassword.password !== "" : true) &&
              password !== "" &&
              confirmPassword !== "" &&
              password.length >= 12 &&
              confirmPassword.length >= 12 &&
              password === confirmPassword &&
              isValid
            )
          }
          onClick={handleSave}
        />
      </div>
    </>
  );
};
export default UpdatePassword;
